import { Reveal } from "./Reveal";

export const Approach = ({ t }) => (
  <section id="approach" className="py-24 md:py-32 lg:py-40 bg-green text-bone" data-testid="approach-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center mb-16 md:mb-24">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] font-bold text-bone/60 mb-6">{t.approach.eyebrow}</p>
            <h2 className="font-display font-medium text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-2xl">
              {t.approach.title}
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.12}>
            <div className="relative aspect-[4/5] sm:aspect-[3/2] lg:aspect-[4/5] overflow-hidden">
              <img
                src={`${process.env.PUBLIC_URL}/timo-workshop.webp`}
                alt="Timo Schewik moderiert einen Workshop"
                className="absolute inset-0 w-full h-full object-cover object-top"
                data-testid="approach-image"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-bone/15" />
            </div>
          </Reveal>
        </div>
      </div>

      <div className="border-t border-bone/20">
        {t.approach.chapters.map(([num, title, body], i) => (
          <Reveal key={num} delay={i * 0.05}>
            <div className="grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-bone/20 group" data-testid={`approach-${num}`}>
              <div className="md:col-span-2 font-accent text-6xl md:text-7xl text-bone/50 group-hover:text-accent-light transition-colors duration-500">
                {num}
              </div>
              <h3 className="md:col-span-4 font-display text-2xl md:text-3xl leading-tight">{title}</h3>
              <p className="md:col-span-6 text-base md:text-lg text-bone/75 leading-relaxed max-w-xl">{body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
